import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userState: null, 
};

const facultyProfileSlice = createSlice({
  name: 'facultyProfile',
  initialState,
  reducers: {
    setState: (state, action) => {
      // console.log(action.payload, "This is the action payload");
      state.userState = action.payload.userState; 
    },

    resetState: (state) => {
      state.userState = null;
    }
  },
});

// Export actions
export const {
  setState,
  resetState
} = facultyProfileSlice.actions;

export const selectUserState = (state) => state.facultyProfile.userState;

export default facultyProfileSlice.reducer;
